module.exports = __webpack_public_path__ + "static/img/ikonaTekst-OFF.80b2fbcc.png";